import { Fragment, ReactElement } from 'react';
import classNames from 'classnames';
import { Table, flexRender } from '@tanstack/react-table';

interface TableHeaderProps<T> {
  table: Table<T>;
  pinnedLeft: string[];
  pinnedRight: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCellClassNames?(value: any, colId: string): string[];
  onExpandRow?(row: T): ReactElement;
}

export const TableBody = <T extends object>({
  table,
  pinnedLeft,
  pinnedRight,
  getCellClassNames,
  onExpandRow
}: TableHeaderProps<T>) => {
  return (
    <tbody>
      {table.getRowModel().rows.map((row) => {
        return (
          <Fragment key={row.id}>
            <tr key={row.id} className="table-body-row">
              {row.getVisibleCells().map((cell) => {
                const cellClassNames: string[] = getCellClassNames
                  ? getCellClassNames(cell.getValue(), cell.column.columnDef.id || '')
                  : [];
                return (
                  <td
                    key={cell.id}
                    style={{ maxWidth: cell.column.columnDef.maxSize }}
                    className={classNames(
                      cellClassNames,
                      cell.column.id === 'row-select' && 'row-select-cell',
                      pinnedLeft.includes(cell.column.id) && 'pinned-left',
                      pinnedRight.includes(cell.column.id) && 'pinned-right'
                    )}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                );
              })}
            </tr>
            {row.getIsExpanded() && typeof onExpandRow === 'function' && (
              <tr>
                <td className="expand-content-cell">{onExpandRow(row.original)}</td>
              </tr>
            )}
          </Fragment>
        );
      })}
    </tbody>
  );
};
